var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.367,
    height: 87.189,
    viewBox: "0 0 200.367 87.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M0-58.861H200.367V-146.05H0Z",
    transform: "translate(0 146.05)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(0 146.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(0 -146.05)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(103.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M-8.415,0A12.465,12.465,0,0,0-20.88,12.465,12.465,12.465,0,0,0-8.415,24.929,12.465,12.465,0,0,0,4.05,12.465,12.465,12.465,0,0,0-8.415,0m-5.979,14.158a1.693,1.693,0,0,1-1.693-1.693,1.693,1.693,0,0,1,1.693-1.693A1.692,1.692,0,0,1-12.7,12.465a1.693,1.693,0,0,1-1.693,1.693m5.979,0a1.693,1.693,0,0,1-1.693-1.693,1.692,1.692,0,0,1,1.693-1.693,1.693,1.693,0,0,1,1.693,1.693,1.693,1.693,0,0,1-1.693,1.693m5.978,0A1.693,1.693,0,0,1-4.13,12.465a1.692,1.692,0,0,1,1.693-1.693A1.693,1.693,0,0,1-.743,12.465a1.694,1.694,0,0,1-1.694,1.693",
    transform: "translate(20.88 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(0 -145.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M0,0V7.721H6.378V23.5h8.727V7.721h6.378V0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(24.166 -145.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M-5.892-10.424H-.521v8.057H8.207v-23.5H-.521v8.056H-5.892v-8.056H-14.62v23.5h8.728Z",
    transform: "translate(14.62 25.864)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(51.018 -145.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M-12.691-11.33H-22.761v-1.679h8.728v-6.713h-8.728V-21.4h9.4v-6.713H-31.489v23.5h18.8Z",
    transform: "translate(31.489 28.114)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(0 -146.05)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(79.548 0.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M-14.5-11.784c0-5.035-5.371-5.874-5.371-5.874v-.168s4.364-.839,4.364-4.867c0-3.525-3.021-6.547-10.574-6.547-5.2,0-9.9.336-9.9.336v23.5s4.7.336,10.07.336c8.391,0,11.413-3.021,11.413-6.714M-27.259-23.2h1.175c1.174,0,1.846.672,1.846,1.511s-.672,1.51-1.846,1.51h-1.175Zm0,8.728h1.343c1.343,0,2.014.672,2.014,1.679s-.671,1.678-2.014,1.678h-1.343Z",
    transform: "translate(35.986 29.239)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(130.55 0.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M-5.892-10.877h.336l4.028,7.721H8.542L2.836-12.22S5.857-13.9,5.857-18.766,2.5-26.99-4.885-26.99c-5.036,0-9.735.336-9.735.336v23.5h8.728Zm0-9.734h1.007a1.905,1.905,0,0,1,2.014,1.846A1.906,1.906,0,0,1-4.885-16.92H-5.892Z",
    transform: "translate(14.62 26.99)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(155.052 -145.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M-12.691-11.33H-22.761v-1.679h8.728v-6.713h-8.728V-21.4h9.4v-6.713H-31.489v23.5h18.8Z",
    transform: "translate(31.489 28.114)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(0 -146.05)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(176.869 0.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M-15.863-8.158c0-7.216-4.5-12.084-13.427-12.084-5.371,0-10.07.336-10.07.336v23.5s4.7.336,10.07.336c8.929,0,13.427-4.867,13.427-12.085m-14.77-4.7h1.343c2.518,0,4.028,1.51,4.028,4.7s-1.51,4.7-4.028,4.7h-1.343Z",
    transform: "translate(39.361 20.242)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(2.036 28.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M-16.262-5.2c0-4.146-3.554-7.7-12.439-7.7-6.121,0-11.65.395-11.65.395V15.139s5.529.395,11.847.395c9.872,0,13.427-3.554,13.427-7.9C-15.077,1.712-21.4.725-21.4.725v-.2s5.133-.987,5.133-5.726m-13.821-.593H-28.7c1.382,0,2.172.79,2.172,1.777s-.79,1.777-2.172,1.777h-1.382ZM-28.5,8.425h-1.579V4.477H-28.5c1.58,0,2.369.79,2.369,1.975s-.789,1.974-2.369,1.974",
    transform: "translate(40.35 12.898)",
    fill: "#ffde16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(30.2 28.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M-16.261-6.531c0-5.726-3.948-9.675-12.637-9.675-5.923,0-11.451.4-11.451.4V11.831h10.267V2.748h.4l4.738,9.082H-13.1L-19.816,1.169s3.554-1.975,3.554-7.7M-28.9-4.36h-1.184V-8.7H-28.9a2.241,2.241,0,0,1,2.371,2.172A2.241,2.241,0,0,1-28.9-4.36",
    transform: "translate(40.349 16.206)",
    fill: "#ffde16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(59.682 -116.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M-14.4-5.331v-7.9H-35.721V14.413h22.113v-7.9H-25.453V4.541h10.268v-7.9H-25.453V-5.331Z",
    transform: "translate(35.721 13.228)",
    fill: "#ffde16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(83.373 -116.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M-18.794-10.263l-2.962-15.2h-9.082l-2.962,15.2-2.172-15.2H-46.634l5.923,27.641h11.452L-26.3-11.843l2.962,14.018h11.451l5.923-27.641H-16.622Z",
    transform: "translate(46.634 25.466)",
    fill: "#ffde16"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M212.408-69.522h10.268V-97.163H212.408Z",
    transform: "translate(-85.604 -19.702)",
    fill: "#ffde16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(141.808 -116.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M-7.731,0H-19.183V27.641H-8.915V15.4L-2.2,27.641H9.249V0H-1.017V12.241Z",
    transform: "translate(19.183)",
    fill: "#ffde16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(0 -146.05)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(174.184 28.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M-10.663-6.531A8.746,8.746,0,0,1-5.529-4.36l4.738-7.5s-3.554-4.344-11.057-4.344A14.29,14.29,0,0,0-26.459-1.792,14.29,14.29,0,0,0-11.848,12.621C-3.95,12.621-.4,7.882-.4,7.882V-1.792H-9.874V2.946h-.789A4.562,4.562,0,0,1-15.4-1.792a4.562,4.562,0,0,1,4.738-4.739",
    transform: "translate(26.459 16.206)",
    fill: "#ffde16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0.155 61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M-9.688-5.934A7.941,7.941,0,0,1-5.025-3.961l4.305-6.816s-3.229-3.946-10.045-3.946A12.983,12.983,0,0,0-24.039-1.629a12.983,12.983,0,0,0,13.275,13.1c6.816,0,10.045-3.946,10.045-3.946L-5.025.7A7.941,7.941,0,0,1-9.688,2.677a4.145,4.145,0,0,1-4.305-4.306,4.145,4.145,0,0,1,4.305-4.3",
    transform: "translate(24.039 14.723)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(24.913 60.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M-9.446,0C-17.7,0-23.437,5.741-23.437,13.095S-17.7,26.19-9.446,26.19,4.547,20.45,4.547,13.095-1.194,0-9.446,0m0,17.4a4.072,4.072,0,0,1-3.946-4.305A4.072,4.072,0,0,1-9.446,8.789,4.072,4.072,0,0,1-5.5,13.095,4.072,4.072,0,0,1-9.446,17.4",
    transform: "translate(23.437)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(56.488 -84.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M-14.532,0l-4.126,13.634L-22.783,0H-36.058V25.114h9.327V11.122l4.305,13.992h7.534l4.306-13.992V25.114h9.328V0Z",
    transform: "translate(36.058)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(0 -146.05)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(95.598 61.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M-7.266,0C-13.007,0-18.03.359-18.03.359V25.473H-8.7V17.4s1.795.18,3.229.18c6.1,0,9.687-3.588,9.687-8.791S.626,0-7.266,0m0,10.763H-8.7V6.816h1.436A2.036,2.036,0,0,1-5.114,8.789a2.036,2.036,0,0,1-2.152,1.974",
    transform: "translate(18.03)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(146.548 -84.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M-11.141,0V11.122L-17.24,0h-10.4V25.114h9.327V13.992l6.1,11.122h10.4V0Z",
    transform: "translate(27.644)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(173.818 -84.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M-10.657,0l-2.512,7.176L-15.681,0H-26.443l8.61,15.428v9.687H-8.5V15.428L.106,0Z",
    transform: "translate(26.443)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0 -146.05)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(117.126 61.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M-7.413-9.271l.346-.418s.142-.1.284-1.33c.121-1.036.589-3.806.73-4.637a1.924,1.924,0,0,0,.02-.483s-.3-.279-.1-.522.182-.228.142-.309-.2-.531.02-.75A3.848,3.848,0,0,1-5-17.876v0l.061,0,.06,0v0a3.844,3.844,0,0,1,.972.155c.223.22.061.669.02.75s-.061.066.143.309-.1.522-.1.522a1.87,1.87,0,0,0,.021.483c.141.831.609,3.6.729,4.637.143,1.226.284,1.33.284,1.33l.346.418a3.079,3.079,0,0,1,.72,1.712c.024,1.784.029,6.833.029,9.668H8.514S1.195-22.862,1.159-23.005h-12.2L-18.394,2.108h10.23c0-2.835.006-7.884.03-9.668a3.083,3.083,0,0,1,.72-1.712",
    transform: "translate(18.394 23.005)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a02a20dd948b4e7cb34e0635bd014e9.svg";
export { ForwardRef as ReactComponent };